/**
 * Created by r4zi4l on 23.06.2022
 */

const Scale9SpriteResizeTo = function (duration, width, height) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._form = cc.size();
    this._to = cc.size();

    this.initWithDuration(duration, cc.size(width, height));
};

Scale9SpriteResizeTo.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: Scale9SpriteResizeTo,

    initWithDuration: function (duration, to) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            this._to = to;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._from = target.getContentSize();
    },

    update: function (time) {
        time = this._computeEaseTime(time);
        this.target.setContentSize(this._from.width + (this._to.width - this._from.width) * time, this._from.height + (this._to.height - this._from.height) * time);
    }
});